/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateServiceContentMap } from './createServiceContentMap';
import { ServiceCategoryCodeEnum } from './serviceCategoryCodeEnum';


export interface ServiceDto { 
    id: string;
    serviceId: number;
    serviceName?: string;
    createdOn: Date;
    active: boolean;
    serviceProviderId: number;
    serviceProviderName?: string;
    serviceCode?: string;
    price?: number;
    shortCode?: string;
    keyword?: string;
    expiryDate?: Date;
    activeDate?: Date;
    serviceCategoryCode: ServiceCategoryCodeEnum;
    operatorIds?: string;
    mobileOriginatingCount?: number;
    mobileTerminatingCount?: number;
    vasSystemServiceCode?: string;
    serviceContentMaps?: Array<CreateServiceContentMap>;
}
